// SEARCH JS
document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.querySelector('.header__icon--search');
  const modal = document.querySelector('.search-modal');
  const closeBtn = document.querySelector('.search-modal__close-button');
  const overlay = document.querySelector('.modal-overlay');

  function openModal() {
    modal.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', closeModal);

  // ESC key support (Shopify standard)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
});


// SEARCH GRID
document.querySelectorAll('.change-column-product .item').forEach(button => {
button.addEventListener('click', function() {
  let column = this.dataset.column;
  let grid = document.querySelector('.search-results-grid');

  grid.classList.remove('columns-2', 'columns-3', 'columns-4');
  grid.classList.add('columns-' + column);

  document.querySelectorAll('.change-column-product .item').forEach(btn => {
    btn.classList.remove('active');
  });

  this.classList.add('active');
});
});


// SEARCH JS
document.addEventListener('DOMContentLoaded', function () {
const blogSearchInput = document.getElementById('blog-search-input');
const resultsContainer = document.getElementById('search-results-container');

const searchInput = document.getElementById('SearchInput');
const clearBtn = document.getElementById('SearchClear');

let articles = [];

try {
  const jsonData = document.getElementById('blog-articles-json')?.textContent;
  if (jsonData) {
    articles = JSON.parse(jsonData);
  }
} catch (e) {
  console.error('Invalid blog JSON');
}

if (blogSearchInput && resultsContainer) {

  blogSearchInput.addEventListener('input', function () {
    const query = this.value.trim().toLowerCase();

    if (query.length > 0) {
      const filtered = articles.filter(article =>
        article.title.toLowerCase().includes(query)
      );
      displayResults(filtered);
    } else {
      hideResults();
    }
  });

  function displayResults(results) {
    resultsContainer.innerHTML = '';

    if (results.length > 0) {
      results.forEach(result => {
        const div = document.createElement('div');
        div.classList.add('search-result-item');
        div.innerHTML = `<a href="${result.url}">${result.title}</a>`;
        resultsContainer.appendChild(div);
      });

      resultsContainer.style.display = 'block';
    } else {
      hideResults();
    }
  }

  function hideResults() {
    resultsContainer.style.display = 'none';
    resultsContainer.innerHTML = '';
  }

  document.addEventListener('click', function (event) {
    if (
      !blogSearchInput.contains(event.target) &&
      !resultsContainer.contains(event.target)
    ) {
      hideResults();
    }
  });
}
if (searchInput && clearBtn) {

  function toggleClearButton() {
    clearBtn.style.display = searchInput.value.length > 0 ? 'flex' : 'none';
  }

  searchInput.addEventListener('input', toggleClearButton);

  clearBtn.addEventListener('click', function () {
    searchInput.value = '';
    searchInput.focus();
    toggleClearButton();
  });

  toggleClearButton();
}
});

